<style lang="less">
.default-page {
  // img {
  //   width: 95px;
  //   height: 95px;
  // }
  .no-text {
    color: rgb(189, 192, 197);
    font-size: 14px;
    padding: 16px 0 20px;
  }
  background: #fff;
  height: 100vh;
  z-index: 9;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<template>
  <div class="default-page">
    <div style="text-align: center">
      <img :src="imgUrl" :width="imgWidth" :height="imgHeight">
      <div class="no-text">{{text}}</div>
      <div name="opt">
        <slot name="opt"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    imgUrl: {
      type: String,
      default: require('../../image/global/error.png')
    },
    imgWidth: {
      type: String,
      default: '95px'
    },
    imgHeight: {
      type: String,
      default: '95px'
    }
  }
}
</script>

